<template>
    <div class="app-layout">
        <HeaderNavigation>
            <div class="d-flex flex-column min-vh-100">
                <div class="flex-grow-1">
                    <slot />
                </div>
            </div>
        </HeaderNavigation>
    </div>
</template>


<script setup>
import HeaderNavigation from '@/components/HeaderNavigation.vue';
import signalRService from '@/services/signalRService';
import { onMounted } from 'vue';


onMounted(()=>{
    if(!signalRService.connection){
        signalRService.initializeConnection();
    }
});

</script>